'use strict';

import { LOGIN_MEMBER } from "../constants/ActionTypes";

const initialGAState = {
    results: {},
    UIdata: {}
};

export default function (state = initialGAState, action = {}) {
    switch (action.type) {
        case LOGIN_MEMBER.LOGIN_MEMBER_RESULTS:
            return Object.assign({}, state, {
                results: [...state.results, action.data]
            });
        case LOGIN_MEMBER.LOGIN_MEMBER_UI:
            return Object.assign({}, state, {
                UIdata: [...state.UIdata, action.data]
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./common/reducers/loginMemberUI.js